// Central data-testid registry.
export const HOME = {
  emergentLink: 'emergent-link',
};

export const NAV = {
  logo: 'nav-logo',
  home: 'nav-home',
  services: 'nav-services',
  about: 'nav-about',
  projects: 'nav-projects',
  contact: 'nav-contact',
  cta: 'nav-cta-estimate',
  mobileToggle: 'nav-mobile-toggle',
  mobileMenu: 'nav-mobile-menu',
};

export const HERO = {
  section: 'hero-section',
  ctaPrimary: 'hero-cta-primary',
  ctaSecondary: 'hero-cta-secondary',
  scroll: 'hero-scroll',
};

export const QUOTE = {
  form: 'quote-form',
  name: 'quote-input-name',
  phone: 'quote-input-phone',
  email: 'quote-input-email',
  service: 'quote-select-service',
  message: 'quote-input-message',
  submit: 'quote-submit',
  success: 'quote-success',
};

export const SERVICES_IDS = {
  section: 'services-section',
  card: (id) => `service-card-${id}`,
};

export const CTA = { estimateBtn: (place) => `cta-estimate-${place}` };

export const ADMIN = {
  page: 'admin-leads-page',
  table: 'admin-leads-table',
  row: (id) => `admin-lead-row-${id}`,
  statusSelect: (id) => `admin-lead-status-${id}`,
  delete: (id) => `admin-lead-delete-${id}`,
  statTotal: 'admin-stat-total',
  statNew: 'admin-stat-new',
  statContacted: 'admin-stat-contacted',
  statWon: 'admin-stat-won',
};
